
import React, {FC, useCallback, useMemo} from 'react';
import {BarVisualizer, MediaDeviceMenu, TrackReferenceOrPlaceholder, TrackToggle, useLocalParticipant, usePersistentUserChoices, VoiceAssistantControlBarProps} from '@livekit/components-react';
import {Track} from 'livekit-client';

import * as styles from './styles.module.scss';

type MicrophoneProps = Partial<VoiceAssistantControlBarProps>;

export const Microphone: FC<MicrophoneProps> = ({
	saveUserChoices = true,
	onDeviceError,
}) => {
	const {saveAudioInputEnabled, saveAudioInputDeviceId} = usePersistentUserChoices({
		preventSave: !saveUserChoices,
	});

	const {localParticipant, microphoneTrack} = useLocalParticipant();
	const micTrackRef: TrackReferenceOrPlaceholder = useMemo(() => {
		return {
			participant: localParticipant,
			source: Track.Source.Microphone,
			publication: microphoneTrack,
		};
	}, [localParticipant, microphoneTrack]);

	const microphoneOnChange = useCallback(
		(enabled: boolean, isUserInitiated: boolean) => {
			if (isUserInitiated) {
				saveAudioInputEnabled(enabled);
			}
		},
		[saveAudioInputEnabled],
	);

	return (
		<div className={styles.microphone}>
			<TrackToggle
				source={Track.Source.Microphone}
				showIcon={true}
				onChange={microphoneOnChange}
				onDeviceError={(error) => {
					onDeviceError?.(
						{source: Track.Source.Microphone, error}
					);
				}}
			>
				<BarVisualizer
					trackRef={micTrackRef}
					barCount={7}
					options={{minHeight: 5}}
				/>
			</TrackToggle>
			<div className='lk-button-group-menu'>
				<MediaDeviceMenu
					kind='audioinput'
					onActiveDeviceChange={(_kind, deviceId) =>
						saveAudioInputDeviceId(deviceId ?? 'default')
					}
				/>
			</div>
		</div>
	);
};
